import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Activity, Clock, Plus, Route as RouteIcon, Target, Trash2, UserPlus } from "lucide-react";

// Trainer-side running plans for a client.
const RunningTab = ({
  deleteTrainerRunningPlan,
  setAssignRunningPlanOpen,
  setNewTrainerRunningPlan,
  setTrainerRunningPlanOpen,
  trainerDifficultyLabels,
  trainerFormatRunTime,
  trainerIntervalTypeNames,
  trainerRunningPlans,
}) => {
  return (
    <div className="running-trainer-view">
      <div className="view-header">
        <h1><Activity size={24} /> Plany Cardio</h1>
        <div style={{display: 'flex', gap: '8px'}}>
          <Button size="sm" onClick={() => { setNewTrainerRunningPlan({ name: "", description: "", goal: "", difficulty: "medium", intervals: [], tags: [], estimated_distance_km: "", estimated_duration_minutes: "", client_id: "" }); setTrainerRunningPlanOpen(true); }}><Plus size={16} /> Nowy plan</Button>
          <Button variant="outline" size="sm" onClick={() => setAssignRunningPlanOpen(true)}><UserPlus size={16} /> Przypisz</Button>
        </div>
      </div>

      {trainerRunningPlans.length === 0 ? (
        <Card className="empty-card"><CardContent className="empty-content"><RouteIcon size={40} /><p>Brak planów biegowych</p><p className="text-muted">Utwórz plan biegowy dla swoich klientów</p></CardContent></Card>
      ) : (
        <div className="running-plans-list">
          {trainerRunningPlans.map(plan => (
            <Card key={plan.id} className="running-plan-card">
              <CardContent>
                <div className="plan-card-header">
                  <h3>{plan.name}</h3>
                  <div style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                    <Badge variant="secondary">{({running:"Bieg",treadmill:"Bieżnia",ergometer:"Ergometr",nordic_walking:"Nordic"})[plan.activity_type || "running"]}</Badge>
                    <Badge variant="outline">{trainerDifficultyLabels[plan.difficulty] || plan.difficulty}</Badge>
                    <Button variant="ghost" size="sm" onClick={() => deleteTrainerRunningPlan(plan.id)}><Trash2 size={14} /></Button>
                  </div>
                </div>
                {plan.goal && <p className="plan-goal-text"><Target size={14} /> {plan.goal}</p>}
                {plan.description && <p className="text-muted text-sm">{plan.description}</p>}
                <div className="plan-meta-row">
                  <span><Clock size={14} /> {plan.estimated_duration_minutes || "?"} min</span>
                  <span><RouteIcon size={14} /> {plan.estimated_distance_km || "?"} km</span>
                  <span>{plan.intervals?.length || 0} interwałów</span>
                </div>
                {plan.intervals?.length > 0 && (
                  <div className="intervals-preview">
                    {plan.intervals.slice(0, 5).map((int, idx) => (
                      <Badge key={idx} variant="secondary" className={`interval-badge interval-${int.type}`}>
                        {trainerIntervalTypeNames[int.type]} {trainerFormatRunTime(int.duration_seconds)}
                      </Badge>
                    ))}
                    {plan.intervals.length > 5 && <Badge variant="outline">+{plan.intervals.length - 5}</Badge>}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default RunningTab;
